import './style.css';
import { useEffect, useState } from 'react';
import {
  Link,
  useLocation,
} from 'react-router-dom';
import { Trans, useLingui } from '@lingui/react/macro';
import useAlarmsStore, {getMaxSeverity} from 'store/alarms';
import Cookies from 'js-cookie';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';


/**
 * Super simple navigation component
 * @module Navigation
 * @param {object} props
 * @param {array} props.routes array of route definition objects
 * @returns {React.ReactElement}
 *
 * Dependencies:
 * [Link](https://reactrouter.com/en/main/components/link)
 * [useLocation](https://reactrouter.com/en/6.22.2/hooks/use-location)
 * @example
 * <Navigation routes={routes} />
 */

function Navigation({routes}) {
  const { _ } = useLingui();
  const location = useLocation();
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();
  const [alarmsStore] = useAlarmsStore();
  const [severity, setSeverity] = useState('ok');

  useEffect(() => {
    setSeverity(getMaxSeverity(alarmsStore.alarms));
  }, [alarmsStore]);

  async function logOut(event) {
    event.preventDefault();
    // document.cookie = 'AuthToken=; Max-Age=0; path=/; domain=' + location.host;
    Cookies.remove('AuthToken');
    // try {
    //   await cookieStore.delete('AuthToken');
    // } catch (e) {
    //   console.log('wtf', e);
    // }

    window.location.href = '/login';
  }

  return (
    <nav>
      {/* <Link to="/" className={`home ${(location.pathname == '/' ? 'active' : '')}`}>Home</Link> */}
      {/** We can use our route models to dynamically compile our Links */}
      {location.pathname != '/get-started' ?
        routes.map((route) => {
          if (route.hideFromNav) return;
          if (
            route.access &&
            !route.access.some(permission => usersStoreActions.checkAccess(permission, rolesStore.roles))
          ) return;

          const activeClass = location.pathname.includes(route.path) ? 'active' : '';
          const statusClass = route.id == 'alarms' && alarmsStore.alarms.length ? 'hasAlarms' : '';
          return (
            <Link
              to={route.id}
              className={`${route.id} ${activeClass} ${statusClass} ${severity}`}
              key={route.path}
            ><Trans>{_(route.trans)}</Trans></Link>
          )
        })
      : null}
      <a href="/login" className="logout" onClick={logOut}>
        <Trans>Log Out</Trans>
      </a>
    </nav>
  )
}

export default Navigation;
